/**
 * SHAR-1332 - rules of the charter quote form that are easy to get wrong inside a hook.
 */

/** The route as one comparable string, codes trimmed and upper-cased. */
export function routeKey(origin: string | null | undefined, dest: string | null | undefined): string {
  const n = (c: string | null | undefined) => (c ?? '').trim().toUpperCase();
  return `${n(origin)}>${n(dest)}`;
}

/** Did the route change from `previous` (empty: nothing was known yet, so no change)? */
export function routeChanged(previous: string, next: string): boolean {
  return !!previous && previous !== next;
}

/**
 * The currency to write into the operator-price field when `aircraft` is selected, or
 * null to leave the field alone. `applied` is the id of the aircraft whose currency is
 * already in the field (for a saved quote: its own aircraft, whose saved currency wins).
 * Without this the form, opened on a saved quote, replaced the quote's currency with the
 * aircraft's the moment the aircraft list loaded.
 */
export function aircraftCurrencyToApply(
  aircraft: { id: string; currencyCode?: string | null } | null | undefined,
  applied: string | null,
): string | null {
  if (!aircraft?.currencyCode) return null;
  return aircraft.id === applied ? null : aircraft.currencyCode;
}
